var _style, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "133781077_10258349") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00AEFF } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: #00AEFF;stroke: #263238;stroke-miterlimit:10;stroke-width: 2 } \n\t\t.s3 { fill: none;stroke: #263238;stroke-linecap: round;stroke-miterlimit:10;stroke-width: 2 } \n\t\t.s4 { fill: #263238 } \n\t\t.s5 { fill: #7a7a7a } \n\t\t.s6 { fill: #8c8c8c } \n\t\t.s7 { fill: none;stroke: #263238;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s8 { fill: #263238;stroke: #263238;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s9 { fill: #00AEFF;stroke: #263238;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s10 { fill: none;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s11 { fill: #ffffff;stroke: #263238;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s12 { fill: #828282;stroke: #263238;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s13 { fill: #e3e3e3;stroke: #263238;stroke-linejoin: round;stroke-width: 2 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Background Simple"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m49.8 626.7q1.4 9.1 3.4 18.1c17 79.7 69.4 150 129.1 195.6 26.1 20 54.6 36.2 84.4 49 195.2 83.8 333.6-58.5 414.3-77.8 80.8-19.3 207.6-56.6 256-218.9 36.8-123.4 15.6-263.2-83.7-361.3-11-10.8-22.8-21.1-35.7-30.8-23.9-18.1-51.2-34.2-82.1-47.8-88.6-38.9-170.7-44.4-264.3-14.9-21.8 6.8-44.2 15.4-66.4 8.7-16.2-4.8-28.8-16.4-6.3-26 26.5-11.1 18.3-56.3-40.5-49.8-98.2 11-167.2 89.7-219 176.8-63.5 106.9-108.9 252.8-89.2 379.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.7
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m49.8 626.7q1.4 9.1 3.4 18.1c17 79.7 69.4 150 129.1 195.6 26.1 20 54.6 36.2 84.4 49 195.2 83.8 333.6-58.5 414.3-77.8 80.8-19.3 207.6-56.6 256-218.9 36.8-123.4 15.6-263.2-83.7-361.3-11-10.8-22.8-21.1-35.7-30.8-23.9-18.1-51.2-34.2-82.1-47.8-88.6-38.9-170.7-44.4-264.3-14.9-21.8 6.8-44.2 15.4-66.4 8.7-16.2-4.8-28.8-16.4-6.3-26 26.5-11.1 18.3-56.3-40.5-49.8-98.2 11-167.2 89.7-219 176.8-63.5 106.9-108.9 252.8-89.2 379.1z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m245.5 679.8c0 25.6-7.9 46.3-17.6 46.3-9.7 0-17.6-20.7-17.6-46.3 0-25.5 7.9-46.2 17.6-46.2 9.7 0 17.6 20.7 17.6 46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m282.7 651.3c-5.5 17.4-16.1 29.5-23.7 27.1-7.5-2.4-9.2-18.4-3.7-35.8 5.5-17.3 16.1-29.4 23.7-27 7.5 2.4 9.2 18.4 3.7 35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m153.3 755.9c-17.9-3.1-31.4-11.9-30-19.7 1.3-7.8 16.9-11.6 34.8-8.6 18 3 31.4 11.8 30.1 19.6-1.3 7.9-16.9 11.7-34.9 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m299.3 713.1c-15 14.9-32.7 21.3-39.6 14.4-6.8-6.9-0.2-24.5 14.7-39.4 15-14.9 32.7-21.3 39.6-14.4 6.8 6.9 0.2 24.6-14.7 39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m196 672.4c14.5 21 18.8 43.2 9.7 49.5-9.2 6.3-28.4-5.6-42.9-26.7-14.5-21-18.8-43.1-9.6-49.5 9.1-6.3 28.3 5.7 42.8 26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m229.1 723.7l1.4 140.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m227.5 662.6l1.6 61.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m227.6 652.7l-0.1 4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m205.6 718.9c8.8 18.5 16 41.1 17.4 66.7v87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m175.3 672.6c8.2 9.4 20.3 25.3 30.3 46.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m165.8 662.5c0 0 1.8 1.7 4.8 4.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m260.8 725.4c-10.3 14.2-20.6 32.8-28.6 56.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m281.1 702.1c-6.2 5.9-13.2 13.6-20.3 23.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m302.7 685.6c0 0-6.2 3.2-15.4 10.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m260.1 674.1c-9.8 30.7-22.9 76.1-29 115.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m266 655.8c-1.7 5.2-3.7 11.4-5.9 18.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m272.1 638.2c0 0-1.7 4.7-4.4 12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m187.3 743c12.2 4.6 28.9 17.5 34.7 34.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m164.8 738.4c6.6 0.4 14.6 1.6 22.5 4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m150.2 738.8c0 0 2.2-0.3 5.7-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m188.5 823.5c-16.5 7.7-32.5 8.1-35.9 0.9-3.3-7.2 7.3-19.2 23.8-26.9 16.5-7.7 32.6-8.1 35.9-1 3.4 7.2-7.3 19.3-23.8 27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m188 802.6c5.6-3.4 12.9-7 21.2-9 0 0 5.5-3.7 11.3 0.2 2.2 1.5 1.5 12.6 1.5 12.6v58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m176.2 811.2c0 0 1.6-1.5 4.5-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m306.9 755.9c17.9-3.1 31.4-11.9 30.1-19.7-1.4-7.8-17-11.6-34.9-8.6-18 3-31.4 11.8-30.1 19.6 1.3 7.9 16.9 11.7 34.9 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m273.3 742.8q-3.2 1.2-6.4 2.9c-14.8 7.6-23.9 23.1-23.9 39.8v76.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m297.3 738.3c-6.8 0.3-15.4 1.4-24 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m310 738.8c0 0-1.4-0.2-3.8-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m288.9 808.4c15.7 9.1 31.7 10.9 35.7 4 3.9-6.9-5.7-19.8-21.4-28.9-15.8-9.1-31.8-10.9-35.7-4-4 6.9 5.6 19.8 21.4 28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m292.7 788.8c-5.4-4.2-12.8-8.9-21.4-11.9 0 0-19.6-3.2-24 9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m302.2 797.2c0 0-1-1.1-2.8-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m278.4 860.2c0 4.7-21 8.5-47 8.5-26 0-47-3.8-47-8.5 0-4.7 21-8.5 47-8.5 26 0 47 3.8 47 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m250.2 787.1c0 0-23-4.5-23 11.1 0 15.6 16.3 28.3 23 46.1 6.7 17.9 19.4 18.6 26.1 0.8 6.6-17.9-3-50.6-26.1-58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m234.6 787.8c0 0 20.1 8.2 26 34.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m236.1 822v42.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m281.4 893.4q0-0.4 0-0.7c0-11.7-1.2-22.9-3.4-33.2h-93.9c-2.1 10.3-3.3 21.5-3.3 33.2q0 0.3 0 0.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m181.7 875q-0.4 3.8-0.6 7.8h100q-0.3-4-0.7-7.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m192.9 893.4q0-0.1 0-0.3c0-2.2-1.8-3.9-4-3.9-2.2 0-4 1.7-4 3.9q0 0.2 0 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m213.1 893.4q0.1-0.1 0.1-0.3c0-2.2-1.8-3.9-4.1-3.9-2.2 0-4 1.7-4 3.9q0 0.2 0 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m233.4 893.4q0-0.1 0-0.3c0-2.2-1.8-3.9-4-3.9-2.3 0-4.1 1.7-4.1 3.9q0 0.2 0 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m253.6 893.4q0-0.1 0-0.3c0-2.2-1.8-3.9-4-3.9-2.3 0-4.1 1.7-4.1 3.9q0 0.2 0.1 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m273.8 893.4q0-0.1 0.1-0.3c0-2.2-1.9-3.9-4.1-3.9-2.2 0-4 1.7-4 3.9q0 0.2 0 0.3z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Squares"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m386.2 370.6v76c0 11.3-9.3 20.6-20.6 20.6h-256.1c-11.4 0-20.6-9.3-20.6-20.6v-203.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m88.9 224.4v-62.9c0-11.4 9.2-20.6 20.6-20.6h256.1c11.3 0 20.6 9.2 20.6 20.6v195.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m519.6 779.4v-323.2c0-13.3 10.7-24 24-24h249.2c13.3 0 24 10.7 24 24v78.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m816.8 554.3v274.6c0 13.3-10.7 24-24 24h-249.2c-13.3 0-24-10.7-24-24v-27.8"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Line 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m388.7 294.5h268.5c12.1 0 21.9 9.9 21.9 22v118.3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Picture"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m925.2 342.6h-168.9v-212.6h168.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m882 288.1h-82.5v-103.7h82.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m913 327.2h-144.5v-181.9h144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m876 280.6h-70.5v-88.7h70.5z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m575.8 526.1l-41.2-9.8v-19.6c0-5.9-4.7-10.6-10.6-10.6h-116.1c-5.9 0-10.6 4.7-10.6 10.6v58.9c0 5.9 4.7 10.6 10.6 10.6h116.1c5.9 0 10.6-4.7 10.6-10.6v-19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m455.1 525.2c0-3.7-3-6.6-6.6-6.6-3.7 0-6.7 2.9-6.7 6.6 0 3.7 3 6.7 6.7 6.7 3.6 0 6.6-3 6.6-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m474.3 525.2c0-3.7-3-6.6-6.7-6.6-3.7 0-6.6 2.9-6.6 6.6 0 3.7 2.9 6.7 6.6 6.7 3.7 0 6.7-3 6.7-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m493.4 525.2c0-3.7-3-6.6-6.6-6.6-3.7 0-6.7 2.9-6.7 6.6 0 3.7 3 6.7 6.7 6.7 3.6 0 6.6-3 6.6-6.7z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m297.3 541.1c0 35.8-29 64.8-64.8 64.8-35.7 0-64.7-29-64.7-64.8 0-35.8 29-64.8 64.7-64.8 35.8 0 64.8 29 64.8 64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m292.1 541.1c0 32.9-26.7 59.5-59.6 59.5-32.8 0-59.5-26.6-59.5-59.5 0-32.9 26.7-59.5 59.5-59.5 32.9 0 59.6 26.6 59.6 59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m245.3 562.4l-12.8-21.3-44.6 16.4"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Call Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m630.4 290.9c0-56.2-45.6-101.8-101.9-101.8-56.2 0-101.8 45.6-101.8 101.8 0 56.3 45.6 101.9 101.8 101.9 56.3 0 101.9-45.6 101.9-101.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m616.3 290.9c0-48.4-39.3-87.7-87.8-87.7-48.4 0-87.7 39.3-87.7 87.7 0 48.5 39.3 87.8 87.7 87.8 48.5 0 87.8-39.3 87.8-87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m482.7 238.2c0 0-7.9 4-10 10.2-2.1 6.3-0.4 9.8 0.7 14.9 1.2 5.1 9.3 22.3 25.5 43.4 16.3 21.1 46 37.1 54.5 40.3 8.6 3.3 14 2.1 19.8-1.1 5.8-3.3 10.4-9.8 12.7-16 2.3-6.3 1.6-8.1-0.9-10.7-2.6-2.6-19.5-16.5-25.5-18.3-6.1-1.9-9.5-1-12.1 2.8-2.5 3.7-6 7.1-6 7.1 0 0-15.6-5.8-22.5-13.4-7-7.7-8.6-19.5-8.6-19.5 0 0 10.4-7.4 10.7-10.4 0.2-3 0-6.1-1.9-8.6-1.8-2.6-9.3-18.1-16.9-23.9-7.7-5.8-14.4-0.5-19.5 3.2z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Character 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m730.7 894.2l-5.7-40.5-182.3-6-7.1 46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m542.7 832.1c0 0-5.4 21.1-2.1 23.2 3.2 2.2 177.5 8.7 182.3 7.6 4.9-1.1 4-5 4-8.3 0-3.2-3-14.4-3-14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m817.1 669.7l32.8-31.5c0 0 1.5-23.9 3-26.7 1.6-2.7 18.4-14.6 19.3-16.2 0.9-1.5 4.6-11.3 6.7-8.8 2.2 2.4 2.2 6.7-0.3 11.6-2.4 4.9-4.6 7.3-6.4 10.4-1.8 3-2.1 4.6-2.1 4.6l47.7-13.2c0 0 21.7-2.7 23.2-0.6 1.6 2.1-2.1 4.6-2.1 4.6 0 0 7.9 0.6 8.6 4 0.6 3.3-2.2 3.9-7.1 5.8-4.9 1.8-14.4 6.1-14.4 6.1 0 0-7.3 9.2-10.4 11.6-3 2.5-16.8 6.8-20.2 9.2-3.3 2.5-27.5 15-27.5 15l-33.9 44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m938.9 603.9c0 0-27.6 6.3-38 9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m906.8 637.9c0 0 11.9-4 13.4-6.8 1.6-2.7 12.3-24.5 11.3-28.1-0.9-3.7-3.6-1.9-6.1 2.4-2.4 4.3-11.3 20.5-11.3 20.5l-6.7 0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m859.3 653.1c0 0-1.2-14.6 6.8-18 7.9-3.4 32.4-2.5 32.4-2.5l4-4.2c0 0 6.4-17.8 8.2-20.5 1.9-2.8 4.3-2.8 4.9-0.3 0.7 2.4-6.4 24.4-7.9 28.1-1.5 3.7-4 5.5-6.4 6.7-2.5 1.3-33.4 10.1-33.4 10.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m649.9 562.5c0 0-26.8-13.2-50.9-14.2-24-1.1-36 3.6-48 20.4-12.1 16.7-36.6 88.8-36.6 88.8l54.3 16.2c0 0-1 45-4.2 53.3-3.1 8.4-27.1 79.5-27.1 93.1 0 13.6 3.6 15.1 7.8 17.7 4.2 2.7 169.4 8.9 174.6 8.9 5.2 0 12.5-7.3 13.6-20.9 1-13.6 1.5-35.5 1.5-35.5 0 0 14.2 5.7 24.6 0.5 10.5-5.2 65.3-54.9 69-61.7 3.7-6.8 5.2-13.6 5.7-15.1 0.6-1.6 16.8-21.5 16.8-21.5l-22-39.7-27.2 18.8c0 0-7.8-1.5-14.1 1.6-6.2 3.1-6.2 3.1-6.2 3.1 0 0 0.5-30.3 2-41.8 1.6-11.5-2-30.3-14.6-38.6-12.5-8.4-35.7-11.7-35.7-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m745.9 668.6c-0.3 8.2-0.9 16.8-2.1 23.4-3.1 17.8-15.1 38.2-15.1 42.4 0 4.1 6.2 55.9 6.2 55.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m745.9 642.9c0 0 0.2 5.6 0.2 13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m781.5 676.3c0 0-30.4 30.4-33.5 35.1-3.1 4.7-3.7 16.2-3.7 16.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m802.9 677.4l26.6 34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m634.9 738.1c11.9-4.6 28.7-11.5 42-18.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m619.4 743.8c0 0 3.2-1.1 8.2-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m686.9 719.2c0 0-32.5 17.3-37.7 18.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m612.3 502.4c0 0-15.8 20.4-16.4 26.2-0.6 5.8-14.3 46.6-14.3 46.6l20.1 12.5c0 0 12.1-23.8 15.2-28.1 3-4.2 8.5-6 11.9-8.8 3.3-2.7 8.2-13.7 8.2-13.7l16.7-34.4-16.1-12.5-20.7 16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m645 486.4l-29.3 36.7c-2.3 3-1.8 7.4 1.2 9.7l15.8 12.2c3 2.4 7.4 1.8 9.7-1.3l29.7-40.4c2.5-3.3 1.4-8.1-2.3-10.1l-16.2-8.6c-2.9-1.5-6.5-0.7-8.6 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m644.9 489.7l-26 32.5c-2.1 2.7-1.6 6.6 1.1 8.6l13.9 10.8c2.7 2.1 6.6 1.5 8.6-1.2l26.4-35.7c2.2-3 1.2-7.3-2.1-9l-14.3-7.6c-2.6-1.3-5.8-0.7-7.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m596.5 525.5c0 0 14.3-26.1 16.7-26.8 2.5-0.6 16.5 8.9 16.5 8.9 0 0 7 10 5.8 11.5-1.3 1.6-5.8 0.7-7-0.6-1.3-1.2-5.8-4.5-5.8-4.5l-8-1.5-1.5 7.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m613.8 532.9c0 0 1.3 8.8-0.9 15.2-2.1 6.4-8.8 14.9-15.5 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m615.7 499.4c0 0 4.2-7 7-7 2.7 0 20.7 5.4 21.6 6.3 0.9 1 3.6 4.3 0 5.2-3.7 0.9-16.5-2.1-16.5-2.1l-6.7 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m625.7 492.7c0 0 5.5-4.6 8.5-5.8 3.1-1.2 18.9 3.6 18.6 5.8-0.3 2.1-2.1 3-4.3 3.3-2.1 0.3-13.4-2.4-13.4-2.4l-4.2 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m634.2 486.9c0 0 9.8-6.7 13.1-7.6 3.4-1 8.9-1 9.5 0 0.6 0.9-0.9 3.6-2.5 3.9-1.5 0.3-3.3 0.6-3.3 0.6l-7.6 3.7c0 0-7.9-2.5-9.2-0.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m614.2 587.5l-43.9-26.7-19.9 29.3c0 0-23 11-27.1 23-4.2 12-24.2 38.5-33.1 55.7-8.9 17.3 1.9 41.5 11.8 46.2 10 4.7 29.3 7.9 36.6 2.6 7.3-5.2 19.2-24 23.3-31.3 4.2-7.3 39.2-55.4 39.2-63.8 0-8.4 2.6-15.7 2.6-15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m555.7 592.7c0 0 8.3 16.7 35.5 23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m759.3 483c0 0 6.4-13.8 17.2-30.6 10.8-16.8 8.6-34.8 2.2-40.4-6.3-5.6-8.6-7.1-8.6-7.1l2.3 7.1c0 0-9.4-6.7-19.1-13.4-9.7-6.7-16-8.2-16-8.2l3.7 7.1c0 0-15.7-6.7-27.2-8.6-11.6-1.9-26.6-5.6-24.7-1.5 1.9 4.1 6 7.5 6 7.5 0 0-25.8-4.1-32.1-0.8-6.4 3.4-7.5 6-7.5 6l14.2 2.6c0 0-14.2-0.4-15.3 8.2-1.1 8.6 11.6 6.7 11.6 6.7 0 0-1.5 6-1.5 7.5 0 1.5 10-1.1 10-1.1l-1.5 3.7c0 0 9-1.8 26.6 0 17.5 1.9 28.3 9 28.3 15.7 0 6.7-4.8 10.8-1.1 15.7 3.8 4.8 10.9 6.3 10.5 11.9-0.4 5.6-2.3 15.7 2.6 18 4.8 2.2 12.7 4.1 14.9 1.8 2.3-2.2 4.5-7.8 4.5-7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m673 427.7c0 0-6.7 32.1-10.8 43.7-4.1 11.6-7.1 17.6-7.1 26.9 0 9.3 4.9 36.2 8.6 39.2 3.7 3 19.8 2.3 19.8 2.3 0 0-9 19-11.2 21.6-2.2 2.6-22.4 1.1-22.4 1.1 0 0 12.2 40 20.5 57.6 8.1 17.3 15.3 29.8 18.7 27.6 3.4-2.3 35.5-47.8 38.5-53.4 3-5.6 7.1-8.6 5.6-10.1-1.5-1.5-7.1-11.2-7.1-11.2l14.2-59.8c0 0 16-2.9 21.6-10.8 5.6-7.8 6.4-16 3.8-19.8-2.7-3.7-5.3-4.8-9-3.3-3.7 1.5-4.9 8.5-9 7.4-4.1-1.1-5.9-0.7-5.9-4.1 0-3.3 4.8-13.1 0.7-16.8-4.1-3.7-9.7-4.5-9.7-8.6 0-4.1 7.2-11.4 8.2-16 0.8-3.4-3.3-6.8-3.3-6.8 0 0-19.5-10.4-35.2-11.5-15.6-1.2-29.5 4.8-29.5 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m702.6 477.1c-0.8 2.8-2.7 4.8-4.2 4.4-1.5-0.5-2-3.1-1.2-6 0.9-2.9 2.8-4.9 4.3-4.4 1.4 0.4 2 3.1 1.1 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m674.5 467.7c-0.8 2.9-2.7 4.8-4.2 4.4-1.4-0.4-2-3.1-1.1-6 0.8-2.9 2.7-4.8 4.2-4.4 1.5 0.4 2 3.1 1.1 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m695.8 460.2c0 0 10.1-5.6 17.6 6.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m679.4 456.1c0 0-6-10.1-10.8-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m675.3 478.9l-8.2 15.7 13.4 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m669.3 509.5c0 0 16.1 7.1 32.1-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m674.5 511.4c0 0-2.6 7.1 2.7 7.8 5.2 0.8 12.7-8.2 12.7-8.2 0 0-10.1 2.2-15.4 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m683.5 539.8l34.7-8.6-41 22.7z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Character 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m338.3 146.8c0 0 18.2 9.1 20.5 30.9 2.3 21.8-8.6 33.1-10.5 38.6-1.8 5.4-4.5 21.8-7.7 32.2-3.2 10.5-20.9 25-30.9 26.8-10 1.8-19 5-16.8 8.2 2.3 3.2 2.3 3.2 2.3 3.2 0 0-3.2 4.5-12.7 2.7-9.6-1.8-17.3-8.6-18.2-15-0.9-6.3 4.6-13.6 7.7-14.5 3.2-0.9 11.4 1.8 23.2-4.1 11.8-5.9 44.1-65.8 40.4-85.4-3.6-19.5-3.2-24 2.7-23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m309.2 467.2h39.3c-2.3-7.9-9.3-32.4-11.5-45.6-2.7-15.9-13.6-104.9-19.1-108.1-5.4-3.2-53.1-32.3-55.4-31.4-2.3 1-5.9 3.7-5.9 3.7 0 0 12.7 22.7 18.6 40.4 5.4 16.2 29.9 123.1 34 141z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m267 282.6c0 0 10.5 7.7 14.1 15.9 3.7 8.2 16.8 23.6 16.8 25.9 0 2.2-2.7 3.6-4.1 4.5-1.3 0.9-1.3 0.9-1.3 0.9 0 0 13.1 7.3 13.6 10 0.5 2.7 5 41.3 6.8 49.1 1.8 7.7 1.4 33.1 1.4 33.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m251.7 467.2h62.9c-0.7-11.4-3.6-57.9-7.6-76.5-4.5-21.4-42.7-103.6-42.7-103.6l7.7-27.2-31.7-42.2-25.9 34-18.7 24.5c0 0 49.1 67.7 53.6 83.6 4.1 14.3 2.7 92.3 2.4 107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m251.7 467.2h62.9c-0.7-11.4-3.6-57.9-7.6-76.5-1.6-7.6-7.5-22.9-14.3-39.4l-47.4-0.5c2 3.7 3.4 6.8 4 9 4.1 14.3 2.7 92.3 2.4 107.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m298.1 270.6c0 0 7 20.6 7.6 24.4 0.6 3.8 4.1 7.3 7.9 11.7 3.8 4.4 9.8 13.9 9.8 13.9 0 0 2.5 94 2.5 104.1 0 10.1 19 25.9 23.8 29.4 4.7 3.5 9.1 3.2 13.9 0.6 4.7-2.5 14.9-27.5 16.1-38.5 1.3-11.1-30.3-99.4-30.3-102.5 0-3.2 9.8-21.9 8.2-31.7-1.6-9.8-9.5-22.8-11.1-25-1.6-2.2-20.9-8.5-23.4-8.5-2.5 0-25.6 17.7-25.6 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m359.8 277c0 0 1.9-19.3 0.6-21.2-1.2-1.9-31-13-33.5-11.1-2.5 1.9 0.9 5.7 4.1 8.2 3.2 2.6 11.1 6.3 11.1 6.3l8.2 7 7.3 15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m352.5 253.9c0 0-4.4-11.4-6.6-13-2.2-1.6-18.4-4.4-20.6-4.4-2.2 0-2.8 3.1-0.6 5.7 2.2 2.5 6 3.8 7.3 4.4 1.2 0.6 20.5 7.3 20.5 7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m304.6 261.8l6.3 24.6c0.8 2.8 3.9 4.2 6.4 2.8l17.3-9.4c1.9-1 2.8-3.2 2.2-5.2l-9.3-29.4c-1-3.1-5-4.1-7.3-1.8l-14.4 14.1c-1.1 1.1-1.6 2.7-1.2 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m305.1 259.1l5.3 20.5c0.6 2.3 3.2 3.5 5.3 2.3l14.4-7.7c1.5-0.9 2.3-2.7 1.7-4.4l-7.7-24.4c-0.8-2.6-4.1-3.4-6-1.5l-12 11.7c-0.9 0.9-1.3 2.3-1 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m341.4 319.7c0 0-5.7-4.1-7.5-11.7-1.9-7.6 14.5-32.3 14.5-32.3l-3.8-8.5c0 0-12.6 0.6-14.9 0.6-2.2 0-6-2.5-4.1-5.4 1.9-2.8 23.1-5.1 23.1-5.1 0 0 4.4 1.9 4.8 3.5 0.3 1.6 8.8 18.4 9.1 21.5 0.4 3.2-12.3 39.6-12.3 39.6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m335.6 149.5c0 0 10.5 16.8 11.8 32.3 1.4 15.4-5.9 28.6-11.8 39-5.9 10.5-6.3 20.9-14.5 30.5-8.2 9.5-29.1 22.7-37.3 23.6-8.1 0.9-22.2-13.6-25.4-19.6-3.2-5.9-5.4-9.5-5.4-9.5 0 0-12.3-13.2-9.1-25 3.2-11.8 31.8-19.9 36.3-35.8 4.6-15.9 4.6-40.9 30.9-44.5 26.3-3.7 24.5 9 24.5 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m325.6 201.3c0 0-12.7 16.4-13.6 21.8-0.9 5.5 4.1 9.1 0 10-4.1 0.9-12.7-5.5-12.7-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m282.9 228.1c0 0 10 16.3 25.5 16.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m305.9 197.5c-2 3.1-5.3 4.5-7.3 3.2-2-1.3-2-4.8 0-7.9 2-3 5.2-4.4 7.2-3.1 2 1.3 2 4.8 0.1 7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m332.4 213.9c-1.6 2.4-4.2 3.6-5.8 2.5-1.6-1-1.6-3.9 0-6.3 1.6-2.5 4.2-3.6 5.8-2.6 1.6 1.1 1.6 3.9 0 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m300.7 175.9c0 0 16.3-3.7 22.2 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m332.4 194.5c0 0 10.9 2.7 8.7 12.3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m346.4 142.3c-0.2 4.3-1.8 8.7-4.9 10.9-4.5 3.1-11.8-0.5-16.3-1.4-4.6-0.9-10.5-4.1-21.8 8.2-11.4 12.2-10 26.8-18.2 35.9-8.2 9-28.6 17.7-32.2 24.9-3.7 7.3-1.4 15 7.2 15.9 8.7 0.9 10.5-1.8 10.5-1.8 0 0-5.9 16.8-23.2 20.4-17.2 3.7-26.8-2.7-26.8-2.7 0 0-10.9 7.3-14.1 9.1-3.1 1.8-23.1-2.3-33.1-19.5-10-17.3-7.3-44.5 3.6-54.1 10.9-9.5 31.4-13.1 35.4-30.4 4.1-17.2 18.2-39.5 46.8-45.4 14.8-3.1 30.1-1.8 44.6 2.1 12.4 3.3 29.8 8.7 39.4 17.8 2.3 2.2 3.3 6.1 3.1 10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m259.3 467.2c1.6-15 8-74.5 6.8-85.1-1.3-12.3-19.5-56.8-25.4-64.5-5.9-7.8-49-53.6-49-53.6-4.1 1.3-11.4 11.8-13.2 14.1-1.8 2.2-0.9 7.7-0.9 7.7 0 0-32.7 29.9-40.4 42.2-7 11.1-27.3 118.5-31.2 139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m183 284.4l33.6 36.3 13.2 5-5 13.2c0 0 35.4 43.2 35.9 45 0.4 1.8 1.8 22.2 1.8 22.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m195.3 437.5c-0.1 4.9 0 9.9 0.2 14.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m161.7 331.2c7.9 2.7 17.9 4.7 21.9 12.7 14.5 24.6 13.3 51.4 12.2 78.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m196.7 346.2c0 0 7.7 17.7 4.5 49.5"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Line 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m887.2 894.2h-830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m939.2 894.2h-35.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.4b930fa845d26cd7e4344cda897791b8.svg";
export { ForwardRef as ReactComponent };